// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { MessageSquare } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconMessageSquare(props: any) {
    return <IconBase icon={MessageSquare} {...props} />
  }

  export default IconMessageSquare
  